import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { fetchingState } from '../../helpers/hocs.js'
import { sendFeedback } from '../../store/reducers/visits.js'
import Overlay from '../Overlay'
//import user from '../../../../backend/app/Routes/api/pub/users.js'


const ContactToManager = ({info, role, data, showСonnectToManager, setShowСonnectToManager, connectToManager, comment, error, commentHandler, messageComplete, classList='ContactManagerButton'}) => {
    let user;//текущий пользователь, который сейчас вызывает компонент
    let memberMeeting;//второй участник встречи: если вошли как персона, то это меценат, если как меценат - то персона
    let adminPhone;//телефон администратора для связи
    let expired = (info && info.visitDates && info.visitDates.tries && info.visitDates.tries === 3) ? true : false;//переменная обозначает прошло или нет 3 раунта по 48 часов

    if (info && role) {
        if (role === 'person') {
            user = `${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`
            memberMeeting = `${info.user.surname} ${info.user.name}` 
        } else {
            user = `${info.user.surname} ${info.user.name}`
            memberMeeting = `${info.persons[0].descriptions[0].firstname} ${info.persons[0].descriptions[0].lastname}`
        }
    }
    
    if (data && data.adminsPersons[1] && data.adminsPersons[1].phone) adminPhone = data.adminsPersons[1].phone
    
    return (!info && !role && !data)
        ?
        null
        :
        (
            <div className='ContactToManager'>
                {expired && <div>Дата встречи так и не была согласована</div>}
                <button className={classList} onClick={() => setShowСonnectToManager(true)}>Связаться с менеджером</button>
                <Overlay isActive={showСonnectToManager} onClose={()=> setShowСonnectToManager(false)} klassModifier='is--blured'>
                    {showСonnectToManager &&
                        <div className='EmailPopup ContactToManager__popup'>
                            {!messageComplete
                            ?
                            <div>
                            <h1 className='EmailPopup-h1 EmailPopup-h1-connection'>
                            {expired
                                ?
                                <span>Напишите почему не удалось согласовать дату встречи c {memberMeeting}</span>
                                :
                                <span>Напишите какие вопросы у вас возникли по встрече c {memberMeeting}</span>
                            }
                            </h1>
                            <div className='EmailPopup-kontainer'>
                                <div className='EmailPopup-select '>
                                    <input 
                                        type="text"
                                        className='EmailPopup__field ContactToManager__field'
                                        name="comment"
                                        placeholder='ваш комментарий'
                                        autoFocus
                                        onChange={(e) => commentHandler(e)}
                                        value={comment}
                                    />
                                </div>
                                {(error && showСonnectToManager) && <p className='ContactToManager__error'><FormattedMessage id='date_selection_rounds_expired.error'/></p>}
                                <button className='EmailPopup-submit ContactToManager__send' onClick={(e) => connectToManager(user, e)}><FormattedMessage id='form.send' /></button>
                                <p>или позвоните менеджеру <a href={`tel:+${adminPhone}`}>+{adminPhone}</a></p>
                            </div>
                            </div>
                            :
                            <div className='ReselectDates__request-complete'>
                                Ваш запрос отправлен менеджеру
                            </div>
                            }
                        </div>
                    }
                </Overlay>
            </div>
        )
}
const mapStateToProps = ({ contacts }) => ({ ...contacts });
const mapDispatchToProps = dispatch => bindActionCreators({ sendFeedback }, dispatch)
export default injectIntl(compose(
   
    withState('error', 'setError', false),//свойства ошибки, которые будут запрещать установку времени встречи, если она введена некорректно
    withState('success', 'setSuccess', null),
    withState('showСonnectToManager', 'setShowСonnectToManager', false),//показывать форму для связи с менеджером
    withState('messageComplete', 'setmessageComplete', false),
    withState('comment', 'setComment', ''),
    fetchingState({ multi: true }),
    //connect(mapStateToProps, mapDispatchToProps, mergeProps),
    connect(mapStateToProps, mapDispatchToProps),
    withHandlers({
        connectToManager: ({sendFeedback, comment, error, setError, info, role, setmessageComplete, setShowСonnectToManager, setComment}) => async (user, e) => {
            e && e.preventDefault();
            if (comment.length > 0) {
                const data = {
                    visitId: info._id,
                    from: `${user} (${role})`,
                    message: comment,
                }

                const result = await sendFeedback(data)
                if (result === 200) {
                    setmessageComplete(true)
                    if (error) setError(false)
                    setComment('')
                    setTimeout(() => {
                        setShowСonnectToManager(false)
                        setmessageComplete(false)
                    }, 2000);
                }
            } else setError(true)
 
        },
        commentHandler: ({setComment}) => (e) => {
            //ввод комментария от мецената для смены дат 
            setComment(e.target.value)
        },
    })
)(ContactToManager))


// WEBPACK FOOTER //
// ./src/components/Visits/ContactToManager.jsx